import Employees from '../components/templates/employees';

export const EmployeesContainer = () => {
  return <Employees />;
};
